export const CardLayouts = {
  default: 'default',
  fullWidth: 'fullWidth'
};

export const CardsListLayouts = {
  default: 'default',
  compact: 'compact'
};
